/**
 * Every fan-facing string the web Joining card renders.
 *
 * The Joining card is `design-prompts/27-pool-settings.md` §27.2 card
 * 2. Copy is locked verbatim against `plan.md ## 5.14` (the mobile card's
 * locked copy) and `## 5.30` (the web additions), so the two platforms
 * cannot disagree. GLOSSARY-10 and GLOSSARY-19 are the authorities for the
 * two identifier names: **Pool ID** (public) and **Invite code** (secret). A
 * bare "code" never appears anywhere in this file.
 */

export const JOINING_APPROVE_MYSELF_LABEL = "Approve new members myself";
export const JOINING_APPROVE_MYSELF_DESCRIPTION =
  "New members wait until you or an Admin lets them in.";
export const JOINING_MEMBER_SHARING_LABEL = "Let members invite others";
export const JOINING_MEMBER_SHARING_DESCRIPTION =
  "Members can share this pool's Invite code.";
export const JOINING_PUBLIC_LISTING_LABEL = "Anyone can find this pool";
export const JOINING_PUBLIC_LISTING_DESCRIPTION =
  "A private pool is only found by members and people you invite.";
export const JOINING_INVITE_CODE_LABEL = "Invite code";
export const JOINING_COPY_INVITE_CODE_LABEL = "Copy invite code";
export const JOINING_REGENERATE_LABEL = "Generate a new invite code";
export const JOINING_REGENERATE_CONFIRM_TITLE = "Generate a new invite code?";
export const JOINING_REGENERATE_CONFIRM_BODY =
  "Anyone using the old link won't be able to join.";
export const JOINING_REGENERATE_CONFIRM_LABEL = "Generate new invite code";
export const JOINING_POOL_ID_LABEL = "Pool ID";
export const JOINING_POOL_ID_NOTE = "This is public. The invite code is not.";
export const JOINING_POOL_ID_PENDING_VALUE = "Not set yet";
export const JOINING_INVITE_CODE_UNAVAILABLE =
  "We could not load the Invite code. Try again in a moment.";
export const JOINING_INVITE_CODE_LOADING_LABEL = "Loading the Invite code";
export const JOINING_INVITE_CODE_RETRY_LABEL = "Try again";
